export default function gaEventHanlder() {
  document.addEventListener('click', (e) => {
    if (!e.target.matches('.aw_ga_event')) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'abw_download_pdf',
      EventCategory: `${e.target.dataset.gtmEvent}`,
      EventLabel: `${e.target.dataset.eventLabel}`,
      EventLocation: `${e.target.dataset.eventPlace}`
    });

    // ga('send', {
    //   hitType: 'event',
    //   eventCategory: `${e.target.dataset.gtmEvent}`,
    //   eventAction: `Klick ${e.target.dataset.eventPlace}`,
    //   eventLabel: `${e.target.dataset.eventLabel}`
    // });
  });
}
